export const FIND_DOCUMENT_FAILURE = 'FIND_DOCUMENT_FAILURE';

export const findDocumentFailure = error => ({
    type: FIND_DOCUMENT_FAILURE,
    payload: error,
    error: true,
});
